import dayjs from './dayjs'
import i18n from '../i18n'

export const picker_options = {
  disabledDate(time) {
    return time.getTime() > Date.now()
  },
  shortcuts: [
    {
      text: i18n.t('base.today'),
      onClick(picker) {
        const start = new Date()
        const end = dayjs().endOf('day').toDate()
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('base.yesterday'),
      onClick(picker) {
        const start = dayjs().subtract(1, 'day').startOf('day').toDate()
        const end = dayjs().subtract(1, 'day').endOf('day').toDate()
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('base.past1week'),
      onClick(picker) {
        const start = dayjs().subtract(6, 'day').startOf('day').toDate()
        const end = dayjs().endOf('day').toDate()
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('base.past1month'),
      onClick(picker) {
        const start = dayjs().subtract(1, 'month').startOf('day').toDate()
        const end = dayjs().endOf('day').toDate()
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('base.past3months'),
      onClick(picker) {
        const start = dayjs().subtract(3, 'month').startOf('day').toDate()
        const end = dayjs().endOf('day').toDate()
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('base.since_begin_week'),
      onClick(picker) {
        const start = dayjs().startOf('week').toDate()
        const end = new Date()
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('base.since_begin_month'),
      onClick(picker) {
        const start = dayjs().startOf('month').toDate()
        const end = new Date()
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('base.previous_month'),
      onClick(picker) {
        const start = dayjs().subtract(1, 'month').startOf('month').toDate()
        const end = dayjs().subtract(1, 'month').endOf('month').toDate()
        picker.$emit('pick', [start, end])
      }
    }
  ]
}

const base_filter = [
  {
    label: i18n.t('metric.average_ranking'),
    key: 'avgRank',
    camel_key: 'avg_rank',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('metric.impressions'),
    key: 'impression',
    camel_key: 'impression',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('metric.clicks'),
    key: 'click',
    camel_key: 'click',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: 'CPC',
    key: 'atosaCpc',
    camel_key: 'atosa_cpc',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('metric.ctr'),
    key: 'ctr',
    camel_key: 'ctr',
    checked: true,
    expression: '>',
    value: null,
    is_percent: true
  },
  {
    label: i18n.t('metric.conversions'),
    key: 'broadOrder',
    camel_key: 'broad_order',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('metric.direct_conversions'),
    key: 'directOrder',
    camel_key: 'direct_order',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('metric.items_sold'),
    key: 'broadOrderAmount',
    camel_key: 'broad_order_amount',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('metric.direct_items_sold'),
    key: 'directOrderAmount',
    camel_key: 'direct_order_amount',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: 'GMV',
    key: 'broadGmv',
    camel_key: 'broad_gmv',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('metric.direct_gmv'),
    key: 'directGmv',
    camel_key: 'direct_gmv',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('metric.expense'),
    key: 'cost',
    camel_key: 'cost',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: 'ROI (ROAS)',
    key: 'broadRoi',
    camel_key: 'broad_roi',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false
  },
  {
    label: i18n.t('metric.direct_roi'),
    key: 'directRoi',
    camel_key: 'direct_roi',
    checked: true,
    expression: '>',
    value: null,
    is_percent: true
  },
  {
    label: 'CIR (ACOS)',
    key: 'broadCir',
    camel_key: 'broad_cir',
    checked: true,
    expression: '>',
    value: null,
    is_percent: true
  },
  {
    label: i18n.t('metric.direct_cir'),
    key: 'directCir',
    camel_key: 'direct_cir',
    checked: true,
    expression: '>',
    value: null,
    is_percent: true
  },
  {
    label: i18n.t('metric.conversion_rate'),
    key: 'cr',
    camel_key: 'cr',
    checked: true,
    expression: '>',
    value: null,
    is_percent: true
  },
  {
    label: i18n.t('metric.direct_conversion_rate'),
    key: 'directCr',
    camel_key: 'direct_cr',
    checked: true,
    expression: '>',
    value: null,
    is_percent: true
  },
  {
    label: i18n.t('metric.cost_per_conversion'),
    key: 'cpc',
    camel_key: 'cpc',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('metric.cost_per_direct_conversion'),
    key: 'cpdc',
    camel_key: 'cpdc',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  }
]

export const keyword_ads_filter = [...base_filter]

export const keyword_ads_detail_filter = [
  {
    label: i18n.t('metric.average_ranking'),
    key: 'average',
    camel_key: 'average',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('base.bid_price'),
    key: 'price',
    camel_key: 'price',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('base.shopee_volume'),
    key: 'shopeeVolume',
    camel_key: 'shopee_volume',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  ...base_filter
]

export const keyword_shop_ads_filter = [
  ...base_filter,
  {
    label: i18n.t('metric.product_impressions'),
    key: 'shopItemImpression',
    camel_key: 'shop_item_impression',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('metric.product_clicks'),
    key: 'shopItemClick',
    camel_key: 'shop_item_click',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('metric.product_ctr'),
    key: 'shopCtr',
    camel_key: 'shop_ctr',
    checked: true,
    expression: '>',
    value: null,
    is_percent: true
  }
]

export const keyword_shop_ads_detail_filter = [
  {
    label: i18n.t('base.bid_price'),
    key: 'price',
    camel_key: 'price',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  {
    label: i18n.t('base.shopee_volume'),
    key: 'shopeeVolume',
    camel_key: 'shopee_volume',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  ...keyword_shop_ads_filter
]

export const targeting_ads_filter = [
  {
    label: i18n.t('base.bid_price'),
    key: 'base_price',
    camel_key: 'base_price',
    checked: true,
    expression: '>',
    value: null,
    is_percent: false,
    value2: null
  },
  ...base_filter
]

export const default_report = {
  average: 0,
  ratio_click: 0,
  cir: 0,
  position: 0,
  broad_cir: 0,
  broad_gmv: 0,
  broad_item_count: 0,
  broad_order: 0,
  broad_order_amount: 0,
  broad_roi: 0,
  click: 0,
  cpc: 0,
  atosa_cpc: 0,
  cost: 0,
  ctr: 0.00,
  direct_cir: 0,
  direct_gmv: 0,
  direct_order: 0,
  direct_order_amount: 0,
  direct_roi: 0,
  impression: 0,
  location_in_ads: 0,
  net_gmv: 0,
  order: 0,
  order_amount: 0,
  order_gmv: 0,
  seller_commission_fee: 0,
  seller_commission_rate: 0,
  shop_item_click: 0,
  shop_item_impression: 0,
  checkout: 0,
  cpdc: 0,
  cr: 0,
  direct_cr: 0,
  shop_ctr: 0,
  shopee_volume: 0,
  cpm: 0,
  cpa: 0,
  aov: 0
}

export const base_flag = [
  {
    label: i18n.t('metric.average_ranking'),
    value: 'avg_rank',
    checked: true
  },
  {
    label: i18n.t('metric.impressions'),
    value: 'impression',
    checked: true
  },
  {
    label: i18n.t('metric.clicks'),
    value: 'click',
    checked: true
  },
  {
    label: i18n.t('metric.ctr'),
    value: 'ctr',
    checked: true
  },
  {
    label: i18n.t('metric.conversions'),
    value: 'broad_order',
    checked: true
  },
  {
    label: i18n.t('metric.direct_conversions'),
    value: 'direct_order',
    checked: true
  },
  {
    label: i18n.t('metric.items_sold'),
    value: 'broad_order_amount',
    checked: true
  },
  {
    label: i18n.t('metric.direct_items_sold'),
    value: 'direct_order_amount',
    checked: true
  },
  {
    label: 'GMV',
    value: 'broad_gmv',
    checked: true
  },
  {
    label: i18n.t('metric.direct_gmv'),
    value: 'direct_gmv',
    checked: true
  },
  {
    label: i18n.t('metric.expense'),
    value: 'cost',
    checked: true
  },
  {
    label: 'ROI (ROAS)',
    value: 'broad_roi',
    checked: true
  },
  {
    label: i18n.t('metric.direct_roi'),
    value: 'direct_roi',
    checked: true
  },
  {
    label: 'CIR (ACOS)',
    value: 'broad_cir',
    checked: true
  },
  {
    label: i18n.t('metric.direct_cir'),
    value: 'direct_cir',
    checked: true
  },
  {
    label: i18n.t('metric.conversion_rate'),
    value: 'cr',
    checked: true
  },
  {
    label: i18n.t('metric.direct_conversion_rate'),
    value: 'direct_cr',
    checked: true
  },
  {
    label: i18n.t('metric.cost_per_conversion'),
    value: 'cpc',
    checked: true
  },
  {
    label: i18n.t('metric.cost_per_direct_conversion'),
    value: 'cpdc',
    checked: true
  }
]

export const shop_ads_flag = [
  ...base_flag,
  {
    label: i18n.t('metric.product_impressions'),
    value: 'shopItemImpression',
    checked: true
  },
  {
    label: i18n.t('metric.product_clicks'),
    value: 'shopItemClick',
    checked: true
  },
  {
    label: i18n.t('metric.product_ctr'),
    value: 'shopCtr',
    checked: true
  }
]

export const pas_base_flag = [
  {
    label: i18n.t('metric.average_ranking'),
    value: 'avg_rank',
    checked: true
  },
  {
    label: i18n.t('metric.impressions'),
    value: 'impression',
    checked: true
  },
  {
    label: i18n.t('metric.clicks'),
    value: 'click',
    checked: true
  },
  {
    label: i18n.t('metric.ctr'),
    value: 'ctr',
    checked: true
  },
  {
    label: i18n.t('metric.conversions'),
    value: 'broad_order',
    checked: true
  },
  {
    label: i18n.t('metric.direct_conversions'),
    value: 'direct_order',
    checked: true
  },
  {
    label: i18n.t('metric.items_sold'),
    value: 'broad_order_amount',
    checked: true
  },
  {
    label: i18n.t('metric.direct_items_sold'),
    value: 'direct_order_amount',
    checked: true
  },
  {
    label: 'GMV',
    value: 'broad_gmv',
    checked: true
  },
  {
    label: i18n.t('metric.direct_gmv'),
    value: 'direct_gmv',
    checked: true
  },
  {
    label: i18n.t('metric.expense'),
    value: 'cost',
    checked: true
  },
  {
    label: 'ROI (ROAS)',
    value: 'broad_roi',
    checked: true
  },
  {
    label: i18n.t('metric.direct_roi'),
    value: 'direct_roi',
    checked: true
  },
  {
    label: 'CIR (ACOS)',
    value: 'broad_cir',
    checked: true
  },
  {
    label: i18n.t('metric.direct_cir'),
    value: 'direct_cir',
    checked: true
  },
  {
    label: i18n.t('metric.conversion_rate'),
    value: 'cr',
    checked: true
  },
  {
    label: i18n.t('metric.direct_conversion_rate'),
    value: 'direct_cr',
    checked: true
  },
  {
    label: i18n.t('metric.cost_per_conversion'),
    value: 'cpc',
    checked: true
  },
  {
    label: i18n.t('metric.cost_per_direct_conversion'),
    value: 'cpdc',
    checked: true
  }
]

export const atosa_flag = [
  // {
  //   label: i18n.t('base.target_roas'),
  //   value: 'target_roas',
  //   checked: false
  // },
  {
    label: 'AOV',
    value: 'aov',
    checked: false
  },
  {
    label: 'CPM',
    value: 'cpm',
    checked: false
  }
]



// WEBPACK FOOTER //
// ./src/addon/options.js